import React from "react";
import { Route, Redirect } from "react-router-dom";
import Index from "../pages/STI/Index";
import Principal from "../Components/STI/Portfolio_v1/MetasPortfolio/Principal";
import PrincipalSTI from "../Components/STI/Portfolio_v1/MetasMensais/Principal";
import DashboardSTI from "../Components/STI/Dashboard/Principal";
import Portfolio from "../Components/STI/Dashboard/Portfolio/Index";
import LinhaDeAtuacao from "../Components/STI/Dashboard/LinhaDeAtuacao";
import NovoForm from "../Components/STI/Novo/index";
import FormCadastraProduto from "../Components/STI/Portfolio_v1/MetasPortfolio/FormCadastraProduto";
import Despesas from "../Components/STI/Portfolio_v1/Despesas"
import FrameBI from "../Components/STI/FrameBI";

// Rotas do domínio STI. Exporta só a lista de elementos <Route>/<Redirect>
// (sem <BrowserRouter>/<Switch> próprios) para serem montadas dentro do único
// <Switch> consolidado em pages/Principal/index.js (Fase 5). Precisa vir
// depois das rotas de Produção STI nesse Switch: o "/sti/:unidade" abaixo é
// genérico e, num Switch de primeira-correspondência, não pode sair na frente
// das rotas literais mais específicas de "/sti/producaosti/*".
const routesSTI = [
    <Route key="sti-home" exact path="/sti" component={Index} />,
    <Route key="sti-dashboard" exact path={"/sti/dashboard"} component={DashboardSTI} />,
    <Route key="sti-dashboard-portfolio" exact path={"/sti/dashboard/portfolio"} component={Portfolio} />,
    <Route key="sti-dashboard-linha" exact path={"/sti/dashboard/linha"} component={LinhaDeAtuacao} />,
    <Route key="sti-dashboard-bi" exact path="/sti/dashboard/bi" component={FrameBI} />,
    <Route key="sti-unidade" exact path={"/sti/:unidade"} component={Principal} />,
    <Route key="sti-unidade-novoform" exact path={"/sti/:unidade/novoform"} component={NovoForm} />,
    <Route key="sti-unidade-formcadastro" exact path={"/sti/:unidade/formcadastro"} component={FormCadastraProduto} />,
    <Route key="sti-unidade-despesas-linha" exact path={"/sti/:unidade/despesas/:linha"} component={Despesas} />,
    <Redirect key="sti-unidade-despesas-redirect" from="/sti/:unidade/despesas/" to="/sti/:unidade/despesas/0" />,
    <Route key="sti-unidade-mensais" exact path={"/sti/:unidade/mensais-:_id"} component={PrincipalSTI} />
];

export default routesSTI;
